export enum RoleEnum {
  WORKER = 'Worker',
  ADMIN = 'Admin',
  TEAMOWNER = 'Owner',
}
